import { useContext, useEffect, useState } from 'react'
import { Column } from 'react-table'
import Table from '../../../../../../global/components/table/Table'
import TableTopper from '../../../../../../global/components/table/helpers/table-topper/TableTopper'
import { useParams } from 'react-router-dom'
import TableTitle from '../../../../../../global/components/table/helpers/table-title/TableTitle'
import { getTechAssignedToWorkOrder } from '../../../../api'
import { fetchData } from '../../../../../../global/utils/fetch'
import { ITechnician } from '../../../../../../../../app/entities/Technician'
import { WoDetailContext } from '../../../../context/context'
import LockIcon from '@mui/icons-material/Lock'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import { SUB_MODAL_NAMES } from '../../sub-modals/constants'
import WODetailsSubModal from '../../sub-modals/WODetailsSubModal'
import { UserContext } from '../../../../../../base/components/base-container/BaseContainer'
import hasPermission from '../../../../../../global/utils/user/has-permission'
import { PERMISSIONS } from '../../../../../../global/constants/permissions'

export default function TechniciansTable({
  isReadOnly = false,
}: {
  isReadOnly?: boolean
}) {
  const { id: orderObjectId } = useParams()
  const { user } = useContext(UserContext)
  const { data: order } = useContext(WoDetailContext)
  const [editModalOpen, setEditModalOpen] = useState(false)
  const [modalName, setModalName] = useState<string>('')
  const [refreshIndex, setRefreshIndex] = useState(0)
  const [tableState, setTableState] = useState({
    data: [],
    isLoading: false,
  })

  const [isOpen, setIsOpen] = useState(false)

  const hasPermissions = hasPermission(user).allow(
    PERMISSIONS.WORK_ORDERS.CATEGORY,
    PERMISSIONS.WORK_ORDERS.ENTRIES.LOCK_TECHNICIAN_TO_ORDER.NAME,
  )

  useEffect(() => {
    const fetchTableData = async () => {
      setTableState((prevState) => ({
        ...prevState,
        isLoading: true,
      }))
      const data = await fetchData<ITechnician | undefined>(
        getTechAssignedToWorkOrder(order.objectId),
      )
      setTableState((prevState: any) => ({
        ...prevState,
        data: [data],
        isLoading: false,
      }))
    }
    if (isOpen) {
      fetchTableData()
    }
  }, [isOpen, orderObjectId])

  const columns: Column<ITechnician | any>[] = [
    {
      Header: 'Employee ID',
      accessor: 'employeeId',
    },
    {
      Header: 'Samsara ID',
      accessor: 'samsaraId',
    },
    {
      Header: 'Name',
      accessor: 'name',
    },
    {
      Header: 'Email',
      accessor: 'email',
    },
    {
      Header: 'Lock Status',
      Cell: ({ row: { original } }) => {
        const { lockedOrders } = original as ITechnician
        const isOrderLocked = lockedOrders?.some(
          (lockedOrder) => lockedOrder.objectId === order.objectId,
        )
        return isOrderLocked ? (
          <LockIcon fontSize='small' />
        ) : (
          <LockOpenIcon fontSize='small' />
        )
      },
    },
  ]

  function onRecordClickHandler(row: any) {
    if (isReadOnly || !hasPermissions) return
    setModalName(SUB_MODAL_NAMES.EDIT_LOCKED_TECHNICIAN)
    setEditModalOpen(true)
  }
  function handleClosed() {
    setEditModalOpen(false)
    setModalName('')
  }

  return (
    <div style={{ width: '100%' }}>
      <TableTopper
        isOpen={isOpen}
        onToggleClick={() => setIsOpen(!isOpen)}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <TableTitle>Technicians</TableTitle>
        </div>
        <WODetailsSubModal
          isOpen={editModalOpen}
          handleClosed={handleClosed}
          actionName={modalName}
          triggerRerender={() => setRefreshIndex(refreshIndex + 1)}
        />
      </TableTopper>
      <Table
        columns={columns}
        data={tableState.data}
        isLoading={tableState.isLoading}
        onRowClick={onRecordClickHandler}
        isOpen={isOpen}
        isDisplayMode={true}
      />
    </div>
  )
}
